import VueApollo from 'vue-apollo';
import ApolloClient from 'apollo-boost';
import store from '@/store';
import { bizmatesGraphQlEndpoint } from '@/utils/constants';

const apolloClient = new ApolloClient({
  uri: bizmatesGraphQlEndpoint,
  request: operation => {
    operation.setContext({
      headers: {
        authorization: 'Bearer ' + (store.state.bizmates_token || null),
      },
    });
  },
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

export {
  apolloProvider
};
